<div class="footer bg-black mt-5" role="contentinfo">
    <div class="footer__navigation">
        <div class="container mb-0">
            <div class="row">
                <div class="col-sm-4">
                    <p class="h4 text-white mt-3">Need some help?</p>
                    <div class="row mt-3">
                        <div class="col">
                            <p class="text-muted mt-3">
                                For enquiries that do not require the attention of a particular key contact, please contact us via email:
                            </p>
                            <p><a href="mailto:{{ businessFunction.email }}?subject={{businessFunctionName}}- General Enquiry" class="pt-3"><i class="fa fa-envelope-open-o mr-1"></i> Email us</a></p>
                            <a class="ot-sdk-show-settings pointer" style="color:#00A3E0;">View Cookies</a>
                        </div>
                    </div>
                </div>
                @if (keyContacts != null && keyContacts.length > 0) {
                <div class="col-sm-8 col-lg-6">
                    <p class="h4 text-white mt-3">Interested in finding out more?</p>
                    <div class="row mt-3">
                        @for (keyContact of keyContacts; track keyContact) {
                        <div class="col-sm-6">
                            <p class="text-white mb-1">
                                <strong>{{keyContact?.name}}</strong>
                            </p>
                            <small class="text-muted mb-0 mt-1 text-success">
                                Deloitte {{keyContact?.location}}
                            </small>
                            <p class="mt-0"><a class="text-white" href="mailto:{{ keyContact?.email }}?subject={{businessFunctionName}}- General Enquiry">{{ keyContact?.email }}</a></p>
                        </div>
                        }
                    </div>
                </div>
                }
            </div>
            @if (legalInformation) {
            <div class="footer__legal-content">
                <div class="row">
                    <div class="col-md-12">
                        <p class="text-muted" [innerHTML]="legalInformation"></p>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</div>